import type { ErrorCode } from '../shared/protocol.js';

export class ApiError extends Error {
  constructor(
    readonly code: ErrorCode | 'network',
    readonly status: number,
  ) {
    super(code);
  }
}

export async function api<T>(method: 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE', path: string, body?: unknown): Promise<T> {
  let response: Response;
  try {
    response = await fetch(path, {
      method,
      credentials: 'same-origin',
      headers: body === undefined ? {} : { 'Content-Type': 'application/json' },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch {
    throw new ApiError('network', 0);
  }
  const data = (await response.json().catch(() => ({}))) as { error?: ErrorCode };
  if (!response.ok) throw new ApiError(data.error ?? 'internal_error', response.status);
  return data as T;
}
